import Vue from 'vue'
import * as Ladda from 'ladda'
import 'ladda/css/ladda-themed.scss'

Vue.directive('busy-button', function (el, binding) {
  const promise = binding.value
  const ladda = Ladda.create(el)

  if (!promise) {
    if (!ladda.isLoading()) {
      ladda.stop()
    }
    return
  }

  ladda.start()
  setTimeout(() => promise.then(() => ladda.stop()), 500)
})
